var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.keptAlive)?_c('keep-alive',{attrs:{"include":_vm.cacheEnabledComponentsList}},[_c('router-view')],1):_c('router-view'),_c('div',{class:{ show: _vm.show_snackbar },attrs:{"id":"snackbar"}},[_vm._v("Copied !")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }